import React from "react";
import { Route, Switch } from "react-router-dom";
import { ROUTES } from "./const";
import { useUrl } from "../../../../hooks/usePage";
import { Pagetype } from "../../../../interfaces/Config";
import ExperimentationPlayer from "../Student/ExperimentationPlayer/ExperimentationPlayer";
import TeacherExperimentationModeList from "./TeacherExperimentationModeList/TeacherExperimentationModeList";

const TeacherExperimentationWorkModeRouter = () => {
    const basepath = useUrl(Pagetype.WORKMODE_EXPERIMENTATION);

    return (
        <div
            style={{ height: "100vh", maxHeight: "calc(100 * var(--vh, 1vh))" }}
        >
            <Switch>
                <Route
                    path={`${basepath}/${ROUTES.play}/:experimentationTestId`}
                >
                    <ExperimentationPlayer />
                </Route>
                <Route exact path={basepath}>
                    <TeacherExperimentationModeList />
                </Route>
            </Switch>
        </div>
    );
};

export default TeacherExperimentationWorkModeRouter;
